import { useApi } from '~/composables/useApi';
import { appendAppLocaleToParams, getAppLocaleQuery } from '~/composables/useAppLocale';

export const useCommonApi = () => {
  // 공통 코드 목록 조회
  const fetchCommonCdList = (params: URLSearchParams) => {
    appendAppLocaleToParams(params);
    return useApi('/api/common/codeList_json.do', {
      method: 'POST',
      query: getAppLocaleQuery(),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 코드명 조회
  const fetchCodeNameData = (params: URLSearchParams) => {
    return useApi('/api/common/codeNameData_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 코드명 조회(Serialization)
  const fetchCodeOptionsData = (params: URLSearchParams) => {
    return useApi('/api/common/codeOptionsData_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 댓글창 목록 조회
  const fetchSelectComCommentList = (params: URLSearchParams) => {
    return useApi('/api/common/selectComCommentList_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 댓글 상세 삭제
  const fetchDeleteComCommentData = (params: URLSearchParams) => {
    return useApi('/api/common/deleteComCommentData_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 댓글 상세 등록
  const fetchInsertComCommentData = (params: URLSearchParams) => {
    return useApi('/api/common/insertComCommentData_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 댓글 상세 수정
  const fetchSaveComCommentData = (params: URLSearchParams) => {
    return useApi('/api/common/saveComCommentData_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 사용자 정의 차수 목록
  const fetchSelectEvalCycleList = (params: URLSearchParams) => {
    return useApi('/api/common/selectEvalCycleList.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

    // 사용자 정의 차수 목록(성과, 역량 분기처리)
    const fetchSelectEvalCycleListByEvalGbn = (params: URLSearchParams) => {
      return useApi('/api/common/selectEvalCycleListByEvalGbn.do', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: params.toString()
      });
    };

  // 평가차수(evalCycleCd) 에 따른 인사 코드 목록 조회 ( 직급, 직책, 직위 )
  const fetchInsaCodeList = (params: URLSearchParams) => {
    return useApi('/api/common/insaCodeList_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 인사 코드 목록 조회 ( 직급, 직책, 직위 )
  const fetchInsaYearCodeList = (params: URLSearchParams) => {
    return useApi('/api/common/insaYearCodeList_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 인사 조직 코드 목록 조회
  const fetchInsaDeptList = (params: URLSearchParams) => {
    return useApi('/api/common/deptInsaList_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 사용자 목록 조회
  const fetchUserInsaAllList = (params: URLSearchParams) => {
    return useApi('/api/common/userInsaAllList_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 조직 코드 목록 조회
  const fetchDeptList = (params: URLSearchParams) => {
    return useApi('/api/common/deptList_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 성과조직 코드 목록 조회
  const fetchScDeptList = (params: URLSearchParams) => {
    return useApi('/api/common/scDeptList_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 사용자 목록 조회
  const fetchUserAllList = (params: URLSearchParams) => {
    return useApi('/api/common/userAllList_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 사용자 목록 조회 / 퇴사자도 함께 조회 (페이징 없음)
  const fetchUserAllNoPagingList = (params: URLSearchParams) => {
    return useApi('/api/common/userListNoPaging_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 첨부파일 목록 조회
  const fetchInitAttachFileOld = (params: URLSearchParams) => {
    return useApi('/api/common/initAttachFileOld.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 인사평가 알림 수 탭 노출 조회
  const fetchInsaEvalTargetCntData = (params: URLSearchParams) => {
    return useApi('/api/common/selectInsaEvalTargetCntData.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 공지사항 팝업 노출 여부 조회
  const fetchCheckPopNotice = (params?: URLSearchParams) => {
    return useApi('/api/common/checkPopNotice_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params?.toString() ?? ''
    });
  };

  /**
   * 회사 구독 서비스 코드 목록 조회
   *
   * 응답 serviceTypeList 예: ['01','02','03','04','05',...]
   * 화면 게이팅에 쓰는 코드 — 03: 개인성과, 04: 인사평가, 05: 업무
   * (AS-IS managerDashboardList.jsp L5445 getServiceTypeList)
   */
  const fetchServiceTypeList = () => {
    return useApi('/api/common/selectServiceTypeList.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: ''
    });
  };

  // 단순 메일 발송 (레거시: FormData — userIdList[i], title, contents)
  const fetchSendSimpleMail = (formData: FormData) => {
    return useApi('/api/common/sendSimpleMail.do', {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json'
      }
    });
  };

  return {
    fetchCommonCdList,
    fetchCodeNameData,
    fetchCodeOptionsData,
    fetchSelectComCommentList,
    fetchDeleteComCommentData,
    fetchInsertComCommentData,
    fetchSaveComCommentData,
    fetchSelectEvalCycleList,
    fetchSelectEvalCycleListByEvalGbn,
    fetchInsaCodeList,
    fetchInsaYearCodeList,
    fetchInsaDeptList,
    fetchUserInsaAllList,
    fetchDeptList,
    fetchScDeptList,
    fetchUserAllList,
    fetchUserAllNoPagingList,
    fetchInitAttachFileOld,
    fetchInsaEvalTargetCntData,
    fetchCheckPopNotice,
    fetchServiceTypeList,
    fetchSendSimpleMail
  };
};
